import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
}

const theadData = [
  'Sr. No.',
  'Date',
  'Part Name / No.',
  'Customer',
  'Area',
  'Defect Name',
  'Total Rejection',
  'Total Production',
  'Rejection PPM',
];

const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  const date = useQuery('annual_date');
  return (
    <thead>
      <TableCompHead
        colSpan={11}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading="DATE WISE REJECTION DATA"
      />
      <tr>
        <th colSpan={11} align="left">
          Month : {date}
        </th>
        {/* <th colSpan={12} align="left">
          {isView ? (
            formatDate(moduleData.dailyProduction_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.dailyProduction_date)}
              onChange={(date) => {
                moduleData.dailyProduction_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th> */}
      </tr>
      <tr>
        {theadData.map((heading, index) => (
          <th key={heading + index} colSpan={index === 9 ? 3 : 1}>
            {heading}
          </th>
        ))}
        {/* <th colSpan={2} rowSpan={2}>
          Remarks
        </th> */}
      </tr>
    </thead>
  );
};

export default THead;
